import { jsx, css } from '@emotion/react';

export default ({ name, offset = -64 }) => (
  <div
    css={css`
      position: relative;
    `}
  >
    <div
      id={name}
      css={css`
        position: absolute;
        top: ${offset}px;
      `}
    />
  </div>
);
